"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumToOptions = enumToOptions;
/**
 * Converts a Record<EnumValue, Label> into an array of { label, value } options
 * ready for select/dropdown components.
 *
 * @example
 * const options = enumToOptions(COMPENSATION_TYPE_LABELS);
 * // [{ label: "Salario", value: "salary" }, { label: "Por hora", value: "hourly" }, ...]
 */
function enumToOptions(labels) {
    return Object.entries(labels).map(([value, label]) => ({
        label,
        value,
    }));
}
